import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SMSVerificationModal from 'components/user/SMSVerificationModal';
import { handleFieldError } from 'libs/api/errorHandle';
import { passwordReset } from 'libs/api/user';
import { showNotification } from 'libs/utils';
import { TModalState } from 'modules/types';
import { TPasswordReset } from 'modules/user';
import { ERoute } from 'enums/route.enum';
import { Radio, Button, Form, Input, Typography } from 'antd';
import styled from 'styled-components';
import { FormWrapper, SecondaryColor } from 'GlobalStyles';

const { Title } = Typography;
export const PasswordResetWrapper = styled.div`
  margin: auto;
  maxwidth: 600px;
  text-align: center;

  .small-text {
    color: #000;
    font-size: 13px;
  }
  .secondary-color {
    .ant-radio-button-wrapper {
      border: 1px solid ${SecondaryColor};
      color: ${SecondaryColor};
    }
    .ant-radio-button-wrapper:last-child {
      border-radius: 0 8px 8px 0;
    }
    .ant-radio-button-wrapper:first-child {
      border-radius: 8px 0 0 8px;
    }
  }
  .ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    background: ${SecondaryColor} !important;
    border-color: ${SecondaryColor} !important;
    color: #fff !important;
  }
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
    background-color: ${SecondaryColor};
  }
`;
const PasswordReset = () => {
  const [form] = Form.useForm();
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
  const [emailFound, setEmailFound] = useState('');
  const [radioButton, setRadioButton] = useState('password');
  const [smsVerificationModal, setSMSVerificationModal] = useState<TModalState>({
    record: '',
    visible: false,
  });
  const handleSubmit = async (value: TPasswordReset) => {
    try {
      setSubmitButtonDisabled(true);
      await passwordReset({ userid: value.userid });
      showNotification('success', `${value.userid} 으로 이메일이 발송되었습니다.`);
    } catch (e) {
      handleFieldError(e, form);
      throw e;
    } finally {
      setSubmitButtonDisabled(false);
    }
  };
  const onClickSubmitPassword = () => {
    form.validateFields().then((value) => {
      handleSubmit(value as TPasswordReset);
    });
  };

  function onChange(e: any) {
    setRadioButton(e.target.value);
  }

  return (
    <PasswordResetWrapper>
      {emailFound && emailFound.length > 0 ? (
        <div style={{ maxWidth: '300px', paddingTop: '20px', margin: 'auto' }}>
          <Title level={2}>
            찾으시려는 이메일은
            <br />
            아래와 같습니다.
          </Title>
          <div style={{ color: `${SecondaryColor}`, margin: '20px 0px' }}>{emailFound}</div>
          <Link to={ERoute.UserLogin}>
            <Button type='primary' size='large' style={{ width: '100%' }}>
              로그인 하기
            </Button>
          </Link>
        </div>
      ) : (
        <>
          <Radio.Group
            onChange={onChange}
            className='secondary-color'
            defaultValue='password'
            buttonStyle='solid'
            style={{ margin: '30px auto' }}
          >
            <Radio.Button value='password'>비밀번호 찾기</Radio.Button>
            <Radio.Button value='userid'>아이디 찾기</Radio.Button>
          </Radio.Group>
          {radioButton == 'password' ? (
            <>
              <Title level={2}>비밀번호를 잊으셨나요?</Title>
              <div className='small-text'>
                입력해주신 이메일로 비밀번호를 재설정 할 수 있는 이메일을 발송해드립니다.
              </div>
              <FormWrapper
                style={{
                  maxWidth: '300px',
                  paddingTop: '20px',
                  paddingBottom: '10px',
                }}
              >
                <Form form={form} name='password_reset' className='form-inline' layout='vertical'>
                  <Form.Item
                    name={'userid'}
                    label='이메일'
                    className='form-item'
                    rules={[
                      {
                        type: 'email',
                        message: '이메일 형식이 올바르지 않습니다',
                      },
                      { required: true, message: '이메일을 입력해주세요' },
                    ]}
                  >
                    <Input size='large' placeholder='아이디(이메일)를 입력해주세요' />
                  </Form.Item>
                  <Form.Item shouldUpdate={true} className='form-button'>
                    {() => (
                      <Button
                        type='primary'
                        htmlType='submit'
                        size='large'
                        onClick={onClickSubmitPassword}
                        loading={submitButtonDisabled}
                      >
                        전송하기
                      </Button>
                    )}
                  </Form.Item>
                </Form>
              </FormWrapper>
            </>
          ) : (
            <>
              <Title level={2}>이메일을 잊으셨나요??</Title>
              <div className='small-text'>본인인증을 통해서 가입하신 이메일을 알려드립니다.</div>
              <FormWrapper
                style={{
                  maxWidth: '300px',
                  paddingTop: '20px',
                  paddingBottom: '10px',
                }}
              >
                <Button
                  type='primary'
                  htmlType='submit'
                  size='large'
                  style={{ width: '100%' }}
                  onClick={() => {
                    setSMSVerificationModal({
                      visible: true,
                      record: { type: 'userid' },
                      onFinish: (data: string) => {
                        setEmailFound(data);
                      },
                    });
                  }}
                >
                  본인인증하기
                </Button>
              </FormWrapper>
              <SMSVerificationModal
                modalState={smsVerificationModal}
                setModalState={setSMSVerificationModal}
              />
            </>
          )}
        </>
      )}
    </PasswordResetWrapper>
  );
};

export default PasswordReset;
